
<div class="card-top">
    <div class="card-mood position-relative pt-2">
        <i class="{{icon}}"></i>
    </div>
    <div class="card-comment">
        <span class="card-comment-body" [innerHtml]="task.comment?.body | removeGifUrls: task.comment?.linkPreviews | linky"></span>
        @for (linkPreview of task.comment?.linkPreviews; track linkPreview.url){
            @if(linkPreview.url.slice(-4) === '.gif'){
                <tm-gif-preview [gifPreview]="toGifPreview(linkPreview)"></tm-gif-preview>
            }
        }
    </div>
    <div class="card-options">
        <div data-cy="report-comment" (click)="reportItem()">
            <i class="fa-regular fa-hexagon-exclamation"
               [matTooltip]="'comment-card.options.report' | translate"
               matTooltipPosition="right"></i>
        </div>
    </div>
</div>

<div class="mx-auto">
    @for(linkPreview of task.comment?.linkPreviews; track linkPreview.url){
        @if(linkPreview.url.slice(-4) !== '.gif'){
            <div>
                <tm-link-preview [linkPreview]="linkPreview"></tm-link-preview>
            </div>
        }
    }
</div>
                 